import(/* webpackMode: "eager" */ "C:\\Users\\jor_m\\OneDrive\\TS\\ticsoft-bpms-frontend-sakai-react-10.0.0\\app\\(main)\\page.tsx")